var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-xs bg-blue",attrs:{"type":"button"},on:{"click":_vm.confirmReactivateTestDrive}},[_vm._v("\n    Reactivate\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }